import React from "react";
import { Route, Routes } from "react-router-dom";

import Reset from "./reset";
import Signin from "./signin";
import Apply from "./apply";
import EmailInvite from "./email-invite";

export default function Auth() {
  return (
    <Routes>
      <Route index element={<Signin />} />
      <Route path="signin" element={<Signin />} />
      <Route path="reset" element={<Reset />} />
      <Route path="apply/*" element={<Apply />} />
      <Route path="invitation" element={<EmailInvite />} />

      <Route path="*" element={<Signin />} />
    </Routes>
  );
}
